import { render, staticRenderFns } from "./PageElementUI.vue?vue&type=template&id=4e79ca4e&"
import script from "./PageElementUI.vue?vue&type=script&lang=js&"
export * from "./PageElementUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports